module.exports = require('../promise')(true);